import API from '../api'
import postUrl from './paths'

const toolsEndorseInvoice = (file) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('file', file)
		API.post(
			postUrl.toolsEndorseInvoice,
			formData,
			{},
			{
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/pdf',
				},
			}
		)
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

const toolsEndorseTestCertificate = (file, invoiceList) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('file', file)
		formData.append('invoiceList', JSON.stringify(invoiceList))

		API.post(
			postUrl.toolsEndorseTestCertificate,
			formData,
			{},
			{
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/pdf',
				},
			}
		)
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

const toolsDistanceCalculator = (file) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('file', file)
		API.post(
			postUrl.toolsCalculateDistance,
			formData,
			{},
			{
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/pdf',
				},
			},
			{
				timeout: 1000 * 60 * 5,
			}
		)
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const toolsReconciliationProcess = (bankName, organisationNames, file, file_name, extension) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('file', file)
		API.post(
			postUrl.toolsReconciliationProcess,
			formData,
			{ bankName, organisationNames },
			{
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/vnd.ms-excel',
				},
			}
		)
			.then((response) => {
				const data = response.data
				const blob = new Blob([data], { type: extension })
				const url = window.URL.createObjectURL(blob)
				const a = document.createElement('a')
				a.setAttribute('hidden', '')
				a.setAttribute('href', url)
				a.setAttribute('download', file_name + '_processed.' + extension)
				document.body.appendChild(a)
				a.click()
				document.body.removeChild(a)

				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const uploadDashboardReportApi = (userId, file, reportType) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('file', file)
		API.post(postUrl.uploadDashboardHtmlReport, formData, { userId, reportType })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export { toolsEndorseInvoice, toolsEndorseTestCertificate, toolsDistanceCalculator }
